import { useQuery } from "@tanstack/react-query";
import { searchSupportTicketsIndex } from "entities/algolia/constants";
import { CustomerSupportTicket } from "entities/customerTickets/types";
import { queryClient } from "shared/api/queryClient";

const HITS_PER_PAGE = 1000;

export const getQueryKey = () => {
  return ["unreadSupportMessages"];
};

export const getUnreadSupportMessagesQueryData = () => {
  return queryClient.getQueryData<number>(getQueryKey());
};

export const setUnreadSupportMessagesQueryData = (data: number) => {
  queryClient.setQueryData(getQueryKey(), data);
};

export const invalidateMessagesQueryData = async () => {
  await queryClient.invalidateQueries({ queryKey: getQueryKey() });
};

export const useUnreadSupportMessages = () => {
  return useQuery({
    queryKey: getQueryKey(),
    queryFn: async () => {
      const response =
        await searchSupportTicketsIndex.search<CustomerSupportTicket>("", {
          filters: "adminUnreadMessagesCount > 0",
          hitsPerPage: HITS_PER_PAGE,
          cacheable: false,
        });

      return response.hits.reduce(
        (acc, item) => acc + item.adminUnreadMessagesCount,
        0,
      );
    },
  });
};
